import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './main.component';
import {AuthGuardService} from './guards/auth-guard.guard';
import {NgModule} from '@angular/core';
import {AppStatusResolver, LoginComponent, MsalRedirectComponent} from 'sigale-angular';
import {GestionEquipeComponent} from './gestion-equipe/gestion-equipe.component';
import {AccueilComponent} from './accueil/accueil.component';
import {ValidationTeletravailComponent} from './validation-teletravail/validation-teletravail.component';
import {ReserverUnBureauComponent} from './reserver-un-bureau/reserver-un-bureau.component';
import {PreferencesComponent} from './shared/components/menu/preferences/preferences.component';
import {EtatPageZoneDeTravail} from './reserver-un-bureau/model/etat-page-zone-de-travail.model';
import {PlanningComponent} from './planning/planning.component';
import {GestionNavetteComponent} from './gestion-navette/gestion-navette.component';
import {ReservationNavetteComponent} from './reservation-navette/reservation-navette.component';

const routes: Routes = [
	{
		path: '', component: MainComponent, canActivateChild: [AuthGuardService], canActivate: [AuthGuardService],
		children: [
			{ path: 'accueil', component: AccueilComponent },
			{ path: '', redirectTo: '/accueil', pathMatch: 'full' },
			{ path: 'planning', component: PlanningComponent },
			{ path: 'reserver-un-bureau', component: ReserverUnBureauComponent, data: { contexteAppel: EtatPageZoneDeTravail.RESERVER_BUREAU } },
			{ path: 'visionner-taux-occupation', component: ReserverUnBureauComponent, data: { contexteAppel: EtatPageZoneDeTravail.VISIONNER_TAUX } },
			{
				path: 'gestion-equipe',
				component: GestionEquipeComponent,
				data: {
					droit: 'GESTION_EQUIPE'
				}
			},
			{
				path: 'validation-teletravail',
				component: ValidationTeletravailComponent,
				data: {
					droit: 'VALIDATION_TT'
				}
			},
			{ path: 'preferences', component: PreferencesComponent },
			{
				path: 'gestion-navette',
				component: GestionNavetteComponent,
				data: {
					droit: 'GESTION_NAVETTE'
				}
			},
			{
				path: 'reservation-navette',
				component: ReservationNavetteComponent,
				data: {
					droit: 'RESERVATION_NAVETTE'
				}
			},
		]
	},
	{ path: 'login', component: LoginComponent },
	{ path: 'redirection-sso', component: MsalRedirectComponent },
	{ path: '**', redirectTo: '' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [
		AppStatusResolver,
	]
})

export class AppRoutingModule {
}
